import {observable, action, runInAction, computed} from 'mobx';
import Api from '../../services/api';

class LinksStore {

    @observable public link?:URL;
    @observable public useShortLink:boolean = false;
    @observable public shortLink?:string;

    @action
    public setLink = (link: URL) => {
        this.link = link;
    };

    @action
    public setUseShortLink = (isUse: boolean) => {
        this.useShortLink = isUse;
    };

    @action
    public getShortLink = async () => {
        if(!this.link)
            return;

        try {
            const link = await Api.getShortLink(this.link.href);
            runInAction(() => {
                this.shortLink = link;
            });
        } catch (err) {
            console.error(err)
        }
    }
}

const linksStore = new LinksStore();

export default linksStore;
